export default {
  successorBorrowersChoicesPath: () => '/api/v2/successor-borrower-choices/',
  reconciliationDiscrepanciesTasksPath: () => '/api/v2/reconciliation-discrepancies-tasks/',
};
